// Error interceptor
import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

    constructor(private router: Router) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            catchError(err => {
                if (err.status === 401) {
                    this.router.navigate(['/auth']);
                }
                // On relance l'erreur HTTP originale afin de préserver
                // le status et le body (ex: { statusCode, error: 'batch_number_not_found' }),
                // que les composants ont besoin d'inspecter pour afficher un message explicite.
                return throwError(() => err);
            })
        );
    }
}